<template>
  <div class="actions-in-row">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="$emit('edit', value)"
        >
          <v-icon>mdi-playlist-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.additional.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="delete_(value)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.additional.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import actions from '../mixins/actions'

export default {
  mixins: [ appdata, actions ],
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
#app .actions-in-row {
  width: 109px;
}
</style>
